import { Routes } from '@angular/router';

/**
 * Rutas standalone para la aplicación
 * Reemplaza app-routing.module.ts
 *
 * Nota: Se está migrando de loadChildren a loadComponent
 * cuando los módulos estén listos como standalone
 */
export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./modules/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'FAQ',
    loadComponent: () => import('./modules/global/footer/pages/faq/faq.component').then(m => m.FaqComponent),
    loadChildren: () => import('./modules/global/footer/pages/faq/faq.routes').then(r => r.FAQ_ROUTES)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./modules/global/footer/pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
    loadChildren: () => import('./modules/global/footer/pages/privacy-policy/privacy-policy.routes').then(r => r.PRIVACY_POLICY_ROUTES)
  },
  {
    path: 'terms-conditions',
    loadComponent: () => import('./modules/global/footer/pages/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent),
    loadChildren: () => import('./modules/global/footer/pages/terms-conditions/terms-conditions.routes').then(r => r.TERMS_CONDITIONS_ROUTES)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./modules/auth/pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    loadChildren: () => import('./modules/auth/pages/reset-password/reset-password.routes').then(r => r.RESET_PASSWORD_ROUTES)
  },
  {
    path: 'new-password',
    loadComponent: () => import('./modules/auth/pages/new-password/new-password.component').then(m => m.NewPasswordComponent),
    loadChildren: () => import('./modules/auth/pages/new-password/new-password.routes').then(r => r.NEW_PASSWORD_ROUTES)
  },
  {
    path: 'satisfaction-survey',
    loadComponent: () => import('./modules/dashboard/components/survey-dinamic/survey-dinamic.component').then(m => m.SurveyDinamicComponent),
    loadChildren: () => import('./modules/dashboard/components/survey-dinamic/survey-dinamic.routes').then(r => r.SURVEY_DINAMIC_ROUTES)
  },
  {
    path: 'acc',
    children: [
      {
        path: 'reserve',
        loadComponent: () => import('./modules/hostless/pages/reserve/reserve.component').then(c => c.ReserveComponent)
      }
    ],
  },
  {
    path: 'store-qr',
    loadChildren: () => import('./modules/marketing/store-qr/store-qr.module').then(m => m.StoreQrModule)
  },
  {
    path: '**',
    redirectTo: '/home'
  }
];
